import { Module } from '../../types';

export const llmFoundationsModule2: Module = {
  id: 'llm-foundations-module-2',
  title: 'Module 2: Architectural Understanding',
  description:
    'Understand how LLMs work under the hood. Explore transformer architecture, attention mechanisms, model components, and the training pipeline.',
  duration: '10-12 hours',
  isUnderDevelopment: true,
  content: `# Module 2: Architectural Understanding

## 🚧 Coming Soon!

This module is currently under development.`,
  exercises: [],
  quiz: {
    id: 'llm-2-quiz',
    title: 'Module 2 Quiz',
    description: 'Test your understanding of LLM architecture',
    questions: [
      {
        id: 'q2-placeholder',
        question: 'This quiz is coming soon!',
        choices: ['Option A', 'Option B', 'Option C', 'Option D'],
        correctAnswer: 0,
        explanation: 'Module 2 content is under development.',
      },
    ],
    passingScore: 1,
  },
  resources: [],
};
